import React from "react";

/**
 * The highlighter, one skewed slab per word.
 *
 * Splitting at the space is not cosmetic. A skew is a transform, and a
 * transform applies to an inline element's whole box, not to each line
 * fragment — so a single span around "blijven werken" becomes one rectangle
 * the moment the phrase wraps, and on a phone it always wraps, straight off
 * the right edge. Per word, each slab wraps like any other word.
 *
 * It happens to look better too: two marker strokes rather than one printed
 * box.
 */
export default function Hl({ children }) {
  const words = String(children).split(/\s+/).filter(Boolean);

  return words.map((word, i) => (
    <React.Fragment key={`${word}-${i}`}>
      {i > 0 && " "}
      <span className="hl">
        <span>{word}</span>
      </span>
    </React.Fragment>
  ));
}
